import React, { FC } from 'react';
import { fetchPro } from 'resources/Pro/ProData';

import { useDataFetcherV2 } from 'components/Common/Data/useDataFetcher';

import { AmplitudeExperimentProvider } from './ExperimentProvider';

type ExperimentProviderLayoutProps = {
  children: React.ReactNode;
};

type ProData = {
  id: string;
  email: string;
  organization_uuid: string;
  organization_created_at: string;
};

type ProDataResult = [boolean, ProData];

const ExperimentProviderLayout: FC<ExperimentProviderLayoutProps> = ({ children }) => {
  const [, pro] = useDataFetcherV2(fetchPro) as ProDataResult;

  return (
    <AmplitudeExperimentProvider
      proId={pro.id}
      email={pro.email}
      organizationUuid={pro.organization_uuid}
      orgCreatedAt={pro.organization_created_at}
    >
      {children}
    </AmplitudeExperimentProvider>
  );
};

export default ExperimentProviderLayout;
